
import Vue from "vue";

export default Vue.extend({
  name: "Footer",

  data: () => ({
    leftImage: require("@/assets/images/development.png"),
    rightImage: require("@/assets/images/optim.png"),
  }),
});
